import { MbscResource } from '@mobiscroll/react';
import { useState } from 'react';

import { ResourceOrderContext } from './resource-order-context';

export const ResourceOrderProvider = (props: { children }) => {
  const [draggedResource, setDraggedResource] = useState<MbscResource | null>(
    null
  );
  return (
    <ResourceOrderContext.Provider
      value={{ draggedResource, setDraggedResource }}
    >
      {props.children}
    </ResourceOrderContext.Provider>
  );
};
